module.exports = __webpack_public_path__ + "static/img_oneoff_03@2x-6d8e050f6aabe91b3d7a338e31586bf8.png";